<template>
  <div class="page content">
    <h1 class="title is-2">{{ title }}</h1>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true
      }
    }
  }
</script>